var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavRAccesosActive = function SvgNavRAccesosActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_r_accesos_active_svg__Capa_2",
    viewBox: "0 0 27.83 34.07"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_r_accesos_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.62 14.76V5.7c0-2.73-2.22-4.95-4.95-4.95h-5.53C8.41.75 6.19 2.97 6.19 5.7v2.35",
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.33,
    height: 18.56,
    x: 0.75,
    y: 14.76,
    rx: 3.59,
    ry: 3.59,
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.59,
    cy: 22.34,
    r: 2.63,
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.59 28.43v-3.46",
    fill: "none",
    stroke: "#19d3c5",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavRAccesosActive;